import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux';
import { selectProductCardConfig } from 'store/preferences/selectors'

export const withProductCardConfig = () => compose(
  connect((state) => ({
    productCardConfig: selectProductCardConfig(state),
  })),
)


// WEBPACK FOOTER //
// ./src/components/Canvas/builder/core/withElementConfig.js